/**
 * Format timestamp in timezone-aware format
 * @param timestamp Unix timestamp in milliseconds
 * @param timezone IANA timezone string (e.g., "America/Los_Angeles")
 * @returns Formatted date/time string
 */
export function formatDateTime(timestamp: number, timezone: string): string {
  try {
    return new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    }).format(new Date(timestamp))
  } catch {
    // Fall back to UTC if timezone is invalid
    return new Intl.DateTimeFormat('en-US', {
      timeZone: 'UTC',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    }).format(new Date(timestamp))
  }
}

/**
 * Get display label for a timezone
 * @param timezone IANA timezone string (e.g., "America/Los_Angeles")
 * @returns Display label (e.g., "PST" or "Pacific Time")
 */
export function getTimezoneLabel(timezone: string): string {
  try {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      timeZoneName: 'short',
    })
    const parts = formatter.formatToParts(new Date())
    const tzPart = parts.find(p => p.type === 'timeZoneName')
    return tzPart?.value || timezone
  } catch {
    return 'UTC'
  }
}
